import { render, staticRenderFns } from "./activeStudentDetails.vue?vue&type=template&id=5ac4954f&scoped=true"
import script from "./activeStudentDetails.vue?vue&type=script&lang=js"
export * from "./activeStudentDetails.vue?vue&type=script&lang=js"
import style0 from "./activeStudentDetails.vue?vue&type=style&index=0&id=5ac4954f&prod&lang=scss&scoped=true"
import style1 from "./activeStudentDetails.vue?vue&type=style&index=1&id=5ac4954f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac4954f",
  null
  
)

export default component.exports